export default "__VITE_ASSET__CGL3y0x4__"